import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDownloadOrderLazyQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { Base64FileData } from 'api/types/data';

export const useDownloadOrder = () => {
  const [handler, { data, loading, error: apolloError }] =
    useDownloadOrderLazyQuery();

  const error = useError(apolloError);

  return {
    downloadOrder: useCallback(
      async (orderId: string) => {
        const res = await handler({
          variables: {
            id: orderId,
          },
        });
        return res.data?.file as Base64FileData | undefined;
      },
      [handler]
    ),
    data: data?.file as Base64FileData | undefined,
    loading,
    error,
  };
};
